module.exports = __webpack_public_path__ + "static/media/arrow_right.63d2bbe6.svg";